const px = (id, w = 1600) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMAGES = {
  heroHome: px(18468536, 2000),   // substation at dawn
  serverBlue: px(325229),         // dark server racks, blue light
  fibre: px(5203849),             // optic fibre rows
  serverOps: px(5480781),         // server wiring / access
  substation: px(36695590),       // high-voltage substation
  circuit: px(442150),            // macro circuit board
  solar: px(356036),              // solar field at dusk
};

export const CONTACT = {
  company: 'EDS — EDASOL — Prestação de Serviços (SU), Lda',
  brand: 'EDS Angola — Engineering & Data Solutions',
  hq: {
    line1: 'Edifício KN10, 6.º Piso',
    line2: 'R. Kwame Nkrumah n.º 10, Maianga, Luanda, Angola',
  },
  tech: 'Rua Emílio Mbidi 74A, Alvalade, Luanda, Angola',
  address: 'Edifício KN10, 6.º Piso — R. Kwame Nkrumah n.º 10, Maianga, Luanda, Angola',
  phone: '+244 940 40 40 49',
  phoneHref: '+244940404049',
  email: 'info@edsangola.org',
  nif: '5000933333',
};

export const ADDRESS_LABELS = {
  pt: { hq: 'Sede', tech: 'Escritório técnico' },
  en: { hq: 'Headquarters', tech: 'Technical office' },
};

export const VERTIV_CERTS = [
  { key: 'partner', url: 'https://customer-assets-39nsmqrw.emergentagent.net/job_luanda-engineering/artifacts/npfxv5n0_EDS%20-%20Authorised%20Partner.pdf' },
  { key: 'service', url: 'https://customer-assets-39nsmqrw.emergentagent.net/job_luanda-engineering/artifacts/ubbdb7c0_EDS%20-%20Service%20Provider.pdf' },
];
